(function () {
  class XtraPowerSideText extends PIXI.Container {
    constructor() {
      super();

      this._pulseTime = 4;
      this._currentLayout = null;
      this._powerBarTriggered = false;
      this._xtraPowerActive = false;
      this._gameConfigSet = false;
      this._pulseActiveAnim = null;

      messageBus.subscribe('spinner:GameConfigEvent', this.onGameConfigEvent.bind(this));
      messageBus.subscribe('sidewinder:XtraPowerTriggerEvent', this.onXtraPowerTriggerEvent.bind(this));
      messageBus.subscribe('spinner:XtraPowerIntroEvent', this.onXtraPowerIntroEvent.bind(this));
      messageBus.subscribe('spinner:ShuffleEndEvent', this.reset.bind(this));
      Reflex.registerEventHandler('layoutChange', this.onLayoutChange.bind(this));
      Reflex.addToUpdate(this.update.bind(this));
    }

    initialise() {
      this._jsonPath = this.name;
      this._fillForDefault = undefined;
      this._fillForPortrait = undefined;
      this._xtraPower = undefined;
      this._xtraPowerNext = undefined;
      this._activeNextFeatureDefault = undefined;
      this._activeNextFeaturePortrait = undefined;
      this._pulseTimeline = null;
    }

    onGameConfigEvent() {
      this._fillForDefault = resourceManager.get(this._jsonPath + ':fillForDefault');
      this._fillForPortrait = resourceManager.get(this._jsonPath + ':fillForPortrait');
      this._xtraPower = resourceManager.get(this._jsonPath + ':xtraPower');
      this._xtraPowerNext = resourceManager.get(this._jsonPath + ':xtraPowerNext');
      this._xtraPowerNow = resourceManager.get(this._jsonPath + ':xtraPowerNow');
      this._activeNextFeatureDefault = resourceManager.get(this._jsonPath + ':activeNextFeatureDefault');
      this._activeNextFeaturePortrait = resourceManager.get(this._jsonPath + ':activeNextFeaturePortrait');
      this._activeNowDefault = resourceManager.get(this._jsonPath + ':activeNowDefault');
      this._activeNowPortrait = resourceManager.get(this._jsonPath + ':activeNowPortrait');
      this._gameConfigSet = true;
      this.onLayoutChange();
    }

    update(delta, time) {}

    onXtraPowerTriggerEvent(task) {
      this._powerBarTriggered = true;
      this.showXtraPowerActiveNext();
    }

    onXtraPowerIntroEvent(task) {
      this._xtraPowerActive = true;
      this.hideFillFor();
      this.hideActiveNext();
      this.showActiveNow();
    }

    showXtraPowerActiveNext() {
      this.hideFillFor();
      this.showActiveNext();
      this.startPulseAnimation();
    }

    startActivePulse() {
      gsap.to(this._xtraPowerNow.scale, {
        x: 0.3 * 1.2,
        y: 0.3 * 1.2,
        duration: 0.25,
        ease: 'power1.Out',
        onComplete: () => {
          this._pulseActiveAnim = gsap.to(this._xtraPowerNow.scale, {
            x: 0.3,
            y: 0.3,
            duration: 0.25,
            yoyo: true,
            repeat: -1,
            ease: 'power1.inOut',
          });
        },
      });
    }

    stopActivePulse() {
      this._pulseActiveAnim.kill();
      this._pulseActiveAnim = undefined;

      gsap.to(this._xtraPowerNow.scale, {
        x: 0.3,
        y: 0.3,
        duration: 0.25,
        ease: 'power1.In',
        onComplete: () => {
          this._xtraPowerNow.scale.set(0.3);
        },
      });
    }

    startPulseAnimation() {
      this._pulseTimeline = gsap.timeline({ repeat: -1, repeatDelay: this._pulseTime });

      const baseScale = this._xtraPowerNext.scale.x;
      const pulseScale = baseScale * 1.2;

      this._pulseTimeline.to(
        this._xtraPowerNext.scale,
        {
          x: pulseScale,
          y: pulseScale,
          duration: 0.1,
          yoyo: true,
          repeat: 3,
          ease: 'power1.inOut',
        },
        0
      );
    }

    stopPulseAnimation() {
      if (this._pulseTimeline) {
        this._pulseTimeline.kill();
        this._pulseTimeline = null;
      }
    }

    onLayoutChange() {
      if (!this._gameConfigSet) {
        return;
      }
      this._currentLayout = layoutController.getCurrentLayout();
      console.log('MDS: Layout changed to:', this._currentLayout);
      if (this._xtraPowerActive) {
        this.hideFillFor();
        this.hideActiveNext();
        this.showActiveNow();
      } else if (this._powerBarTriggered) {
        this.hideFillFor();
        this.hideActiveNow();
        this.showActiveNext();
      } else {
        this.hideActiveNext();
        this.hideActiveNow();
        this.showFillFor();
      }
    }

    showFillFor() {
      if (this._currentLayout === 'landscape_default' || this._currentLayout === 'landscape_mobile') {
        this._fillForDefault.visible = true;
      } else if (this._currentLayout === 'portrait_default') {
        this._fillForPortrait.visible = true;
      }
      this._xtraPower.visible = true;
    }

    showActiveNext() {
      if (this._currentLayout === 'landscape_default' || this._currentLayout === 'landscape_mobile') {
        this._activeNextFeatureDefault.visible = true;
      } else if (this._currentLayout === 'portrait_default') {
        this._activeNextFeaturePortrait.visible = true;
      }
      this._xtraPowerNext.visible = true;
    }

    showActiveNow() {
      if (this._currentLayout === 'landscape_default' || this._currentLayout === 'landscape_mobile') {
        this._activeNowDefault.visible = true;
      } else if (this._currentLayout === 'portrait_default') {
        this._activeNowPortrait.visible = true;
      }
      this._xtraPowerNow.visible = true;
    }

    hideFillFor() {
      if (this._currentLayout === 'landscape_default' || this._currentLayout === 'landscape_mobile') {
        this._fillForDefault.visible = false;
      } else if (this._currentLayout === 'portrait_default') {
        this._fillForPortrait.visible = false;
      }
      this._xtraPower.visible = false;
    }

    hideActiveNext() {
      if (this._currentLayout === 'landscape_default' || this._currentLayout === 'landscape_mobile') {
        this._activeNextFeatureDefault.visible = false;
      } else if (this._currentLayout === 'portrait_default') {
        this._activeNextFeaturePortrait.visible = false;
      }
      this._xtraPowerNext.visible = false;
    }

    hideActiveNow() {
      if (this._currentLayout === 'landscape_default' || this._currentLayout === 'landscape_mobile') {
        this._activeNowDefault.visible = false;
      } else if (this._currentLayout === 'portrait_default') {
        this._activeNowPortrait.visible = false;
      }
      this._xtraPowerNow.visible = false;
    }

    reset() {
      this.stopPulseAnimation();
      this.hideActiveNext();
      this.hideActiveNow();
      this.showFillFor();
      this._powerBarTriggered = false;
      this._xtraPowerActive = false;
    }
  }

  let creator = function (json) {
    return new XtraPowerSideText();
  };

  let filesRequired = function () {
    return [];
  };

  resourceManager.registerObjectType('xtraPowerSideText', creator, initialise, filesRequired);
})();
